<template>
  <div>
    <div
      class="p-4 rounded-md"
      :class="{
        'cursor-not-allowed': !props.canSubmit,
        'cursor-pointer': props.canSubmit,
      }"
      :style="{
        backgroundColor: !!props.canSubmit ? `#${primaryColor}` : '#9ca3af',
      }"
      @click="nextStep()"
    >
      <p class="w-full text-center text-white text-xl font-bold">
        {{ __('co_reg_lander_001_text_button_text') }}
      </p>
    </div>
  </div>

  <div class="text-center text-sm">
    <!-- eslint-disable vue/no-v-html -->
    <div
      class="px-8 text-gray-500"
      v-html="__('co_reg_lander_001_text_button_message_title')"
    />
    <!-- eslint-enable vue/no-v-html -->
    <a
      class="underline"
      target="_blank"
      :href="__('co_reg_lander_001_content_privacy_link') ?? '#'"
      :style="{
        color: `#${primaryColor}`,
      }"
    >{{ __('co_reg_lander_001_text_privacy') }}</a>
  </div>
</template>

<script setup>
const props = defineProps({
  primaryColor: {
    type: String,
    required: true,
  },

  canSubmit: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(['submit']);

const nextStep = () => {
  if (!props.canSubmit) {
    return;
  }

  emit('submit');
};
</script>
